var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("common.alerts.alerts_history"),
        "show-filter": true,
        "show-refresh": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { "toggle-filter": _vm.toggleFilter, refresh: _vm.onRefresh },
    },
    [
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") +
                " " +
                _vm.$t("common.alerts.alerts_history"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.onRefresh,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "mb-5" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "filter-item-action mb-5",
                    attrs: { sm: "6", lg: "3", cols: "12" },
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "filter-item-title text-ellipsis",
                        attrs: { for: "enginekey" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.alerts.engine")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.engineIndex,
                            expression: "engineIndex",
                          },
                        ],
                        staticClass: "filter-item-content",
                        staticStyle: { "max-width": "100%", padding: "0.5rem" },
                        attrs: { id: "enginekey", autocomplete: "off" },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.engineIndex = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.getAlertsHistory()
                            },
                          ],
                        },
                      },
                      _vm._l(_vm.engineOptions, function (engine, index) {
                        return _c(
                          "option",
                          {
                            key: index,
                            attrs: { disabled: engine.disabled },
                            domProps: { value: index },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(engine.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("b-col", [
                  _c(
                    "div",
                    { staticStyle: { overflow: "auto" } },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.alertsHistoryList.length
                        ? _c("b-table", {
                            staticClass: "mt-3 table-striped",
                            attrs: {
                              responsive: "",
                              items: _vm.alertsHistoryList,
                              fields: _vm.alertsHistoryFields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDir,
                              "caption-top": "",
                              role: "table",
                              "aria-label": "Historique des alertes",
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "head-clicked": _vm.sortTable,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(MetricsKey)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.monitoring.key." +
                                              data.value
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(ThresholdStatus)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.alerts.threshold_status_value." +
                                              data.value
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(DateStart)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getDate(data.value))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(DateEnd)",
                                fn: function (data) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getDate(data.value))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(Criticality)",
                                fn: function (data) {
                                  return [
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "LOW"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-light-blue",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "MEDIUM"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-yellow",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "HIGH"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-orange",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.translateCriticalityFromDatabase(
                                      data.value
                                    ) == "CRITICAL"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-solid fa-circle color-red",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "common.alerts." +
                                              _vm.translateCriticalityFromDatabase(
                                                data.value
                                              )
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "cell(status)",
                                fn: function (data) {
                                  return [
                                    data.value == 0
                                      ? _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-check color-lime-green",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.value == 1
                                      ? _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-xmark text-danger",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v(
                                        _vm._s(
                                          data.value == 0
                                            ? _vm.$t(
                                                "common.alerts.status_solved"
                                              )
                                            : _vm.$t(
                                                "common.alerts.status_on_going"
                                              )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n              "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mt-5" },
              [
                _c(
                  "b-col",
                  [
                    _c("cm-pagination", {
                      attrs: {
                        maxResultsByPage: _vm.paginationObject.maxResults,
                        firstIndex: _vm.paginationObject.firstIndex,
                        nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                        refreshEvent: _vm.paginationObject.refresh,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }